// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"0ea56dd9","147":"97afaaa2","150":"61abc424","239":"63293496","383":"dcc8203d","453":"6c2fb012","472":"eddf28c9"}[chunkId] + ".chunk.js";
};